import { mapActions } from 'vuex';

export default {
  name: 'LineCallback',
  async mounted() {
    try {
      const { code, state } = this.$route.query;

      if (state === 'takeorder' && code) {
        await this.registerLineNotiy({ code });
      }
      this.$router.replace('/user');
    } catch (ex) {
      console.error(ex);
    }
  },
  methods: {
    ...mapActions('user', {
      registerLineNotiy: 'REGISTER_LINE_NOTIFY',
    }),
  },
};
